module.exports = __webpack_public_path__ + "assets/img/icon4.06194963.png";